<script setup>
import Chart from "./Chart.vue";
import _map from "lodash/map";
import { useForm } from "@/form";
import { onMounted, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { isDarkMode } from "@/theme";

const { t: __ } = useI18n();
const usages = ref([]);

// const usages =
const chartData = computed(() => {
    return _map(usages.value, (usage, key) => {
        return { x: key, y: usage.amount.toFixed(2) };
    });
});

onMounted(async () => {
    usages.value = await useForm().post("dashboard_usages");
});
</script>

<template>
    <div class="flex flex-col px-4 py-6 space-y-3">
        <div class="flex flex-col">
            <p class="text-sm font-medium leading-6 text-gray-600 dark:text-gray-400">{{ __("Coûts") }}</p>
            <span class="mt-1 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">${{ chartData[chartData.length - 1]?.y ?? 0 }}</span>
        </div>
        <Chart :data="chartData" :color="isDarkMode() ? '#ffffff' : '#000000'" :name="__('Coûts')" group="costs" height="50px" />
    </div>
</template>
